import React from 'react';
import { useNavigate } from 'react-router-dom';
import { tsrClient } from '../api/client';
import { Button } from './button';
import { OPS_CONSOLE_PATH } from '../config/ops';

/**
 * "Open Ops Console" entry point for Settings — rendered ONLY when the current user is
 * an allowlisted internal admin (GET /internal/me → 200). The server enforces the
 * allowlist on every /internal/* call regardless of whether this button shows.
 */
export const OpsConsoleLink: React.FC<{ className?: string }> = ({ className }) => {
  const navigate = useNavigate();
  const meQuery = tsrClient.internal.me.useQuery({
    queryKey: ['internal', 'me'],
    retry: false,
    staleTime: 1000 * 60 * 10,
    refetchOnWindowFocus: false,
  });

  if (meQuery.data?.status !== 200) return null;

  return (
    <Button
      variant="secondary"
      size="sm"
      className={className}
      onClick={() => navigate(OPS_CONSOLE_PATH)}
    >
      🎟️ Open Ops Console
    </Button>
  );
};

OpsConsoleLink.displayName = 'OpsConsoleLink';
